/**
 * Стан «Цю вакансію знято» (owner 2026-09-25).
 *
 * Вакансію знято адміном або двома скаргами (`vacancies.removed_at`). Сервер
 * тоді не віддає ні тексту, ні контактів (`removed: true`), тож показуємо лише
 * це пояснення — без кнопок дій. Один компонент на обидва місця: окрема
 * сторінка вакансії і розгорнута картка у стрічці.
 */
import { TgEmoji } from "@/components/TgEmoji";

export function RemovedVacancyNotice({ compact = false }: { compact?: boolean }) {
  return (
    <div
      className={
        "fade-in-up flex flex-col items-center text-center " +
        (compact
          ? "rounded-xl border border-dashed border-ink/15 px-4 py-5"
          : "pt-16")
      }
    >
      <TgEmoji char="❌" size={compact ? 32 : 52} />
      <div
        className={
          "font-display font-bold leading-tight text-ink [text-wrap:balance] " +
          (compact ? "mt-2 text-[0.9375rem]" : "mt-4 text-[1.25rem]")
        }
      >
        Цю вакансію знято
      </div>
      <div
        className={
          "mt-1.5 max-w-[18rem] leading-snug text-ink-dim [text-wrap:balance] " +
          (compact ? "text-[0.75rem]" : "text-[0.8125rem]")
        }
      >
        {/* nbsp: «і» не лишається висіти в кінці рядка. */}
        Її прибрали зі стрічки, тому текст і&nbsp;контакти замовника більше
        недоступні.
      </div>
    </div>
  );
}
